import { render, staticRenderFns } from "./childBuyhand.vue?vue&type=template&id=8cc3fd78&scoped=true"
import script from "./childBuyhand.vue?vue&type=script&lang=js"
export * from "./childBuyhand.vue?vue&type=script&lang=js"
import style0 from "./childBuyhand.vue?vue&type=style&index=0&id=8cc3fd78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc3fd78",
  null
  
)

export default component.exports